import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'
import { AxiosResponse } from 'axios'

export interface Availability {
  start_date: string;
  end_date: string;
}

export interface AvailabilityResponse {
  availabilities: {
    [date: string]: Availability[];
  };
}

interface ListProfessionalAvailabilities {
  professionalUsername: string;
  patientUsername: string;
  startDate: string;
  endDate: string;
  productCode: string;
}

export async function listProfessionalAvailabilities({
  professionalUsername,
  patientUsername,
  startDate,
  endDate,
  productCode,
}: ListProfessionalAvailabilities): Promise<AvailabilityResponse> {
  const { data }: AxiosResponse<AvailabilityResponse> = await axios.get(
    apiEndpoints.PROFESSIONAL_AGENDA_AVAILABILITY(professionalUsername), {
      params: {
        schedule_type: 'PSIC',
        patient_username: patientUsername,
        start_date: startDate,
        end_date: endDate,
        product_code: productCode,
      }
    })


  return data
}
